<template>
  <div class="_premium-id-info">
    <h4 class="_section-title">
      Premium ID
    </h4>
    <p class="_section-content">
      LINE Official Account ทุกบัญชี จะมี ID แบบสุ่มเป็นตัวอักษรผสมตัวเลขเรียกว่า เบสิคไอดี (Basic ID) ไว้ใช้ระบุตัวตนของบัญชี LINE OA นั้น ๆ และไม่สามารถเปลี่ยนแปลงได้
    </p>

    <p class="_section-content">
      การซื้อ พรีเมียมไอดี (Premium ID) คือการซื้อชื่อ ID ที่ทำให้ลูกค้า ของคุณค้นหา LINE OA ของคุณเพื่อเพิ่มเพื่อนได้ง่ายขึ้น ทั้งยัง สร้างการจดจำและบอกต่อง่ายอีกด้วย
    </p>

    <p class="_section-content">
      เบสิคไอดี : @vik9339x<br /> พรีเมียมไอดี: @linebysellsuki
    </p>
  </div>
</template>

<script>
export default {
  name: 'PremiumIdInfo'
}
</script>

<style lang="scss" scoped>
._premium-id-info {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-family: "Prompt", sans-serif;
}

._section-title {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.4;
  letter-spacing: 0%;
  color: #000000;
  margin: 0;
}

._section-content {
  font-family: "Prompt", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  letter-spacing: 0%;
  color: #666666;
  margin: 0;
}
</style>
